import React, { useState, useEffect } from "react";
import { makeStyles, Typography, Grid } from "@material-ui/core/";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";
import {
  getprofileData,
  updateProfileEditData,
} from "../../../../reduxSlices/profileSlice";
import { isObjectEmpty, profileOptionList } from "../../../../utils/general";
import profileStyle from "../../../../components/profile/profileForms/profile.module.css";
import Aux from "../../../../hoc/Auxilliary";
import FormBuilder from "../../../FormBuilder";
import AllFormData from "./formData";
import Backdrop from "../../../Backdrop";
import SnackBar from "../../../SnackBar";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../../reduxSlices/loginSlice";
import {
  clearErrorStatusCode,
  clearErrorMessage,
  clearApplicationData,
  clearApplicantStatus,
  getpreferredGenderCode,
  getInquiryData,
} from "../../../../reduxSlices/applicationSlice";
import localizedStrings from "../../../../utils/localize";
const useStyle = makeStyles((theme) => ({
  formDesignMain: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  formContainer: {
    padding: "0.9rem 0.7rem",
    margin: "0",
    background: "#005598",
    display: "flex",
    alignItems: "center",
    color: "#fff",
  },
  formDesign: {
    width: "95%",
    margin: "0 auto",
  },
}));

var formJson = {};

const ProfileDesign = (props) => {
  const classes = useStyle(props);
  const dispatch = useDispatch();
  const [FormData, setFormData] = useState(AllFormData);
  const profileData = useSelector((state) => state.profileData.profileData);
  const [primaryDetails, setPrimaryDetails] = useState(FormData.primaryDetails);
  const [contact, setContact] = useState(FormData.contact);
  const [emergenencyContact, setEmergenencyContact] = useState(
    FormData.emergenencyContact,
  );
  const [HomeAddress, setHomeAddress] = useState(FormData.HomeAddress);
  const [mailingAddress, setMailingAddress] = useState(FormData.mailingAddress);
  const [billingAddress, setBillingAddress] = useState(FormData.billingAddress);
  const [displayMessage, setDisplayMessage] = useState("");
  for (let key in primaryDetails) {
    formJson[key] = primaryDetails[key].value;
  }
  for (let key in contact) {
    formJson[key] = contact[key].value;
  }
  for (let key in emergenencyContact) {
    formJson[key] = emergenencyContact[key].value;
  }
  for (let key in HomeAddress) {
    formJson[key] = HomeAddress[key].value;
  }
  for (let key in mailingAddress) {
    formJson[key] = mailingAddress[key].value;
  }
  for (let key in billingAddress) {
    formJson[key] = billingAddress[key].value;
  }
  const dataFetchingStatus = useSelector(
    (state) => state.profileData.dataFetchingStatus,
  );

  const errorMessage = useSelector((state) => state.profileData.errorMessage);

  const errorStatusCode = useSelector(
    (state) => state.profileData.errorStatusCode,
  );

  const preferredGenderCode = useSelector(
    (state) => state.applicationData.preferredGenderCode,
  );

  const inquiry = useSelector((state) => state.applicationData.inquiry);

  const [showSnackBar, setShowSnackBar] = useState({
    status: false,
    message: "",
  });

  useEffect(() => {
    let entity = "contact";
    let attributename = "gendercode";
    dispatch(getpreferredGenderCode(entity, attributename));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getInquiryData());
  }, []);

  const setpreferredGenderCode = () => {
    if (
      !isObjectEmpty(preferredGenderCode) &&
      preferredGenderCode?.length != 0
    ) {
      const transformed = preferredGenderCode?.map(
        ({ value: displayValue, attributevalue: value }) => ({
          displayValue: profileOptionList(displayValue),
          value,
        }),
      );
      const newJsonData = { ...primaryDetails };
      newJsonData.gendercode.elementConfig.options = transformed;
    }
  };
  useEffect(() => {
    dispatch(getprofileData(window.localStorage.getItem("x-auth-contactId")));
  }, [dispatch]);
  useEffect(() => {
    const newFormData = { ...FormData };
    for (const key in props.fields) {
      const item = props.fields[key];
      for (const field in item) {
        if (newFormData[key] && newFormData[key][field]) {
          if (item[field].hasOwnProperty("disabled")) {
            newFormData[key][field].elementConfig.disabled =
              item[field].disabled;
          }
          if (item[field].hasOwnProperty("required")) {
            newFormData[key][field].elementConfig.required =
              item[field].required;
          }
        }
      }
    }
    setFormData({ ...FormData, ...newFormData });
  }, [props.title]);

  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
    dispatch(clearApplicationData());
    dispatch(clearApplicantStatus());
    props.history.push("/login");
  };
  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let status = { ...showSnackBar };
        status.status = true;
        status.message = `${localizedStrings.general.sessionexpired}`;
        setShowSnackBar(status);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let status = { ...showSnackBar };
        status.status = true;
        status.message = errorMessage;
        setShowSnackBar(status);
      }
    }
  }, [errorMessage, errorStatusCode]);

  useEffect(() => {
    const newHomeAddress = { ...HomeAddress };
    const newMailingAddress = { ...mailingAddress };
    const newBillingAddress = { ...billingAddress };

    if (inquiry.countries && inquiry.countries?.length > 0) {
      const countries = inquiry.countries.map((country) => ({
        value: country.ses_countrynameid,
        displayValue: country.ses_countryname,
      }));
      newHomeAddress._ses_countryofresidence_value.elementConfig.options =
        countries;
      newMailingAddress.address2_country.elementConfig.options = countries;
      newBillingAddress.address3_country.elementConfig.options = countries;
    }
    setHomeAddress(newHomeAddress);
    setMailingAddress(newMailingAddress);
    setBillingAddress(newBillingAddress);
  }, [inquiry]);

  const [jsonData, setJsonData] = useState(formJson);

  const textFieldChangeHandler = (event) => {
    const formJsonCopy = { ...jsonData };
    formJsonCopy[event.target.name] = event.target.value;
    setJsonData(formJsonCopy);
    dispatch(updateProfileEditData(formJsonCopy));
  };

  useEffect(() => {
    if (!isObjectEmpty(profileData)) {
      const newProfile = { ...profileData };
      newProfile.birthdate = new moment(newProfile.birthdate).format(
        "YYYY-MM-DD",
      );
      let governmentId = newProfile.governmentid;
      if (governmentId != "" && governmentId != null) {
        const newPrimaryDetails = { ...primaryDetails };
        newPrimaryDetails.governmentid.elementConfig.disabled = true;
        if (governmentId.length === 9) {
          const formattedSIN = `xxx xxx ${governmentId.slice(6)}`;
          newProfile.governmentid = formattedSIN;
          newProfile.governmentID = governmentId;
        }
        setPrimaryDetails(newPrimaryDetails);
      }
      setJsonData(newProfile);

      dispatch(updateProfileEditData(newProfile));
    }
    setpreferredGenderCode();
  }, [profileData, dispatch, preferredGenderCode]);

  const handleClose = () => {
    let status = { ...showSnackBar };
    status.status = false;
    setShowSnackBar(status);
  };

  const handelChange = (event, eventName) => {
    const formJsonCopy = { ...jsonData };
    formJsonCopy[eventName] = event.target.value;
    setJsonData(formJsonCopy);
    dispatch(updateProfileEditData(formJsonCopy));
  };

  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    const newPrimaryDetails = { ...primaryDetails };
    newPrimaryDetails.birthdate.elementConfig.label =
      localizedStrings.students.profile.primaryDetails.birthdate;
    newPrimaryDetails.emailaddress1.elementConfig.label =
      localizedStrings.students.profile.primaryDetails.emailaddress1;
    newPrimaryDetails.studentId.elementConfig.label =
      localizedStrings.students.profile.primaryDetails.studentid;
    newPrimaryDetails.firstname.elementConfig.label =
      localizedStrings.students.profile.primaryDetails.firstName;
    newPrimaryDetails.middlename.elementConfig.label =
      localizedStrings.students.profile.primaryDetails.middleName;
    newPrimaryDetails.lastname.elementConfig.label =
      localizedStrings.students.profile.primaryDetails.lastName;
    newPrimaryDetails.gendercode.elementConfig.label =
      localizedStrings.students.profile.primaryDetails.gender;
    newPrimaryDetails.governmentid.elementConfig.label =
      localizedStrings.students.profile.primaryDetails.governmentid;
    setPrimaryDetails(newPrimaryDetails);
    const newContact = { ...contact };
    newContact.mobilephone.elementConfig.label =
      localizedStrings.students.profile.contact.mobilePhone;
    newContact.telephone1.elementConfig.label =
      localizedStrings.applicationpage.home;
    setContact(newContact);
    const newEmergenencyContact = { ...emergenencyContact };
    newEmergenencyContact.name.elementConfig.label =
      localizedStrings.students.profile.emergenencyContact.name;
    newEmergenencyContact.phone.elementConfig.label =
      localizedStrings.students.profile.emergenencyContact.phone;
    newEmergenencyContact.relationship.elementConfig.label =
      localizedStrings.students.profile.emergenencyContact.relationship;
    setEmergenencyContact(newEmergenencyContact);
    const newHomeAddress = { ...HomeAddress };
    newHomeAddress.address1_city.elementConfig.label =
      localizedStrings.students.profile.HomeAddress.address1_city;
    newHomeAddress._ses_countryofresidence_value.elementConfig.label =
      localizedStrings.students.profile.HomeAddress.address1_country;
    newHomeAddress.address1_line1.elementConfig.label =
      localizedStrings.students.profile.HomeAddress.address1_line1;
    newHomeAddress.address1_postalcode.elementConfig.label =
      localizedStrings.application.conatactInformation.homeAddress.address1_postalcode;
    newHomeAddress.address1_stateorprovince.elementConfig.label =
      localizedStrings.students.profile.HomeAddress.address1_stateorprovince;
    setHomeAddress(newHomeAddress);
    const newMailingAddress = { ...mailingAddress };
    newMailingAddress.address2_city.elementConfig.label =
      localizedStrings.students.profile.mailingAddress.address2_city;
    newMailingAddress.address2_country.elementConfig.label =
      localizedStrings.students.profile.mailingAddress.address2_country;
    newMailingAddress.address2_line1.elementConfig.label =
      localizedStrings.students.profile.mailingAddress.address2_line1;
    newMailingAddress.address2_postalcode.elementConfig.label =
      localizedStrings.students.profile.mailingAddress.address2_postalcode;
    newMailingAddress.address2_stateorprovince.elementConfig.label =
      localizedStrings.students.profile.mailingAddress.address2_stateorprovince;
    setMailingAddress(newMailingAddress);
    const newBillingAddress = { ...billingAddress };
    newBillingAddress.address3_city.elementConfig.label =
      localizedStrings.students.profile.billingAddress.address3_city;
    newBillingAddress.address3_country.elementConfig.label =
      localizedStrings.students.profile.billingAddress.address3_country;
    newBillingAddress.address3_line1.elementConfig.label =
      localizedStrings.students.profile.billingAddress.address3_line1;
    newBillingAddress.address3_postalcode.elementConfig.label =
      localizedStrings.students.profile.billingAddress.address3_postalcode;
    newBillingAddress.address3_stateorprovince.elementConfig.label =
      localizedStrings.students.profile.billingAddress.address3_stateorprovince;
    setBillingAddress(newBillingAddress);
    setpreferredGenderCode();
  }, [language]);

  useEffect(() => {
    if (showSnackBar.message === "Data Updated") {
      setDisplayMessage(localizedStrings.general.dataupdatedMessage);
    } else if (showSnackBar.message === "Invalid token") {
      setDisplayMessage(localizedStrings.general.invalidToken);
    } else if (
      showSnackBar.message === "Invalid token or you are missing header token"
    ) {
      setDisplayMessage(localizedStrings.general.invalidTokenandheader);
    } else if (showSnackBar.message === "Something Went Wrong") {
      setDisplayMessage(localizedStrings.general.somethingwentwrong);
    } else {
      setDisplayMessage(showSnackBar.message);
    }
  }, [showSnackBar]);

  return (
    <Aux>
      <Backdrop show={dataFetchingStatus} />
      <SnackBar
        open={showSnackBar.status}
        message={displayMessage}
        handleClose={handleClose}
      />
      <Grid container item className={classes.formDesignMain}>
        <Grid
          direction="column"
          container
          item
          className={`${profileStyle.mainConatiner} ${profileStyle.conatinerWidth}`}
          style={{ alignSelf: "flex-start" }}
        >
          <Typography component="div" className={classes.formContainer}>
            {localizedStrings.students.profile.primaryDetails.primaryDetails}
          </Typography>
          <div className={classes.formDesign}>
            <FormBuilder
              formDetails={FormData.primaryDetails}
              value={jsonData}
              changed={(event) => textFieldChangeHandler(event)}
              handelChange={handelChange}
            />
          </div>
        </Grid>
        <Grid
          className={profileStyle.conatinerWidth}
          direction="column"
          container
        >
          <Grid
            direction="column"
            container
            item
            className={profileStyle.mainConatiner}
          >
            <Typography component="div" className={classes.formContainer}>
              {localizedStrings.students.profile.contact.contact}
            </Typography>
            <div className={classes.formDesign}>
              <FormBuilder
                formDetails={FormData.contact}
                value={jsonData}
                changed={(event) => textFieldChangeHandler(event)}
                handelChange={handelChange}
              />
            </div>
          </Grid>
          <Grid
            direction="column"
            container
            item
            className={profileStyle.mainConatiner}
          >
            <Typography component="div" className={classes.formContainer}>
              {
                localizedStrings.students.profile.emergenencyContact
                  .emergenencyContact
              }
            </Typography>
            <div className={classes.formDesign}>
              <FormBuilder
                formDetails={FormData.emergenencyContact}
                value={jsonData}
                changed={(event) => textFieldChangeHandler(event)}
                handelChange={handelChange}
              />
            </div>
          </Grid>
        </Grid>
        <Grid
          className={profileStyle.conatinerWidth}
          container
          direction="column"
        >
          <Grid
            direction="column"
            container
            item
            className={profileStyle.mainConatiner}
          >
            <Typography component="div" className={classes.formContainer}>
              {localizedStrings.students.profile.HomeAddress.HomeAddress}
            </Typography>
            <div className={classes.formDesign}>
              <FormBuilder
                formDetails={FormData.HomeAddress}
                value={jsonData}
                changed={(event) => textFieldChangeHandler(event)}
                handelChange={handelChange}
              />
            </div>
          </Grid>
          {/* <Grid
            direction="column"
            container
            item
            className={profileStyle.mainConatiner}
          >
            <Typography component="div" className={classes.formContainer}>
            {localizedStrings.students.profile.mailingAddress.mailingAddress}
            </Typography>
            <div className={classes.formDesign}>
              <FormBuilder
                formDetails={FormData.mailingAddress}
                value={jsonData}
                changed={(event) => textFieldChangeHandler(event)}
                handelChange={handelChange}
              />
            </div>
          </Grid> */}
          {/* <Grid
            direction="column"
            container
            item
            className={profileStyle.mainConatiner}
          >
            <Typography component="div" className={classes.formContainer}>
            {localizedStrings.students.profile.billingAddress.billingAddress}
            </Typography>
            <div className={classes.formDesign}>
              <FormBuilder
                formDetails={FormData.billingAddress}
                value={jsonData}
                changed={(event) => textFieldChangeHandler(event)}
                handelChange={handelChange}
              />
            </div>
          </Grid> */}
        </Grid>
      </Grid>
    </Aux>
  );
};

export default withRouter(ProfileDesign);
